import { default as React } from "react";
import { SearchField } from "components/search";
import InputField from "./inputField";

interface OwnState {
    option: SearchField;
    setOptionValue: (option: string, value: any) => void;
    reset: boolean;
    setReset: (value: boolean) => void;
}

type SearchProps = OwnState;

const SearchOption = ({ option, reset, setReset, setOptionValue }: SearchProps) => {

    React.useEffect(() => {
    }, [reset]);


    return (
        <>
            <tr>
                <td style={{ paddingRight: '10px' }}>{option.title}</td>
                <td>
                    <InputField
                        option={option}
                        reset={reset}
                        setReset={setReset}
                        setValue={(v: any) => setOptionValue(option.parameter, v)} />
                </td>
            </tr>

        </>
    );
};

export default SearchOption;
